import { combineReducers } from 'redux';
import Pool from './pool';

// Reducers

const reducers = combineReducers({
  tk:Pool
});


export default reducers;